"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function shouldDisableSaveButton(currentSubcategory) {
    return currentSubcategory.options
        .filter(function (option) { return option.fullOptionFormSettings.isDirty(); })
        .reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.disableSave &&
            option.fullOptionFormSettings.disableSave();
    }, true);
}
exports.default = shouldDisableSaveButton;
//# sourceMappingURL=shouldDisableSaveButton.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/utils/shouldDisableSaveButton.js
// module id = 1838
// module chunks = 2 39 105 108